import { render } from "./SelectionDatagrid.vue?vue&type=template&id=768dfb8b"
import script from "./SelectionDatagrid.vue?vue&type=script&lang=js"
export * from "./SelectionDatagrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__